import $marketAxios from "@/services/config/market-axios";

class ExchangeService {
  geOrdersCurrentList(data) {
    return $marketAxios.post("/exchange/order/personal/current", data);
  }

  getOrdersHistory(data) {
    return $marketAxios.post("/exchange/order/history", data);
  }

  orderCancel(orderId) {
    return $marketAxios.post(`/exchange/order/cancel/${orderId}`);
  }

  orderPreconditionCancel(orderId) {
    return $marketAxios.post(`/exchange/order-precondition/cancel/${orderId}`);
  }

  getOrderDetails(orderId) {
    return $marketAxios.post(`/exchange/order/detail/v2/${orderId}`);
  }

  preconditionDetailsByOrderId(orderId) {
    return $marketAxios.get(
      `/exchange/order-precondition/precondition-details-by-order-id?orderId=${orderId}`
    );
  }

  getOrdersHistoryList(data) {
    return $marketAxios.post("/exchange/order/personal/history", data);
  }

  getOrderStatusListService() {
    return $marketAxios.get("/exchange/order/status/types");
  }

  getPreconditionOrderDetailByOrderID(orderId) {
    return $marketAxios.get(
      `/exchange/order-precondition/details-by-precondition-id?orderId=${orderId}`
    );
  }

  getAllActivePreconditionsByFilterService(data) {
    return $marketAxios.post(
      "exchange/order-precondition/personal/all-active-preconditions",
      data
    );
  }

  getAllActivePreconditionsService(data) {
    return $marketAxios.post(
      "/exchange/order-precondition/all-active-preconditions",
      data
    );
  }

  getAllPreconditionsHistoryService(data) {
    return $marketAxios.post(
      "/exchange/order-precondition/all-determined-preconditions",
      data
    );
  }

  cancelPreconditionOrderService(orderId) {
    return $marketAxios.post(`/exchange/order-precondition/cancel/${orderId}`);
  }

  getPreconditionOrdersHistoryList(data) {
    return $marketAxios.post(
      "/exchange/order-precondition/personal/all-determined-preconditions",
      data
    );
  }

  getPreconditionOrderStatusList() {
    return $marketAxios.get("/exchange/order-precondition/status/types");
  }

  getPreconditionOrderDetailByID(orderId) {
    return $marketAxios.get(
      `/exchange/order-precondition/details-by-precondition-id?id=${orderId}`
    );
  }

  getAllTradeBaseCoin() {
    return $marketAxios.get("/exchange/exchange-coin/units");
  }

  getFavoredMarkets(data) {
    return $marketAxios.post("/exchange/favor/find-favor-symbol-detail", data);
  }

  addFavoredMarkets(data) {
    return $marketAxios.post("/exchange/favor/add", data);
  }

  deleteFavoredMarkets(data) {
    return $marketAxios.post("/exchange/favor/delete", data);
  }

  addOrder(data) {
    return $marketAxios.post("/exchange/order/add", data);
  }

  addPreconditionOrder(data) {
    return $marketAxios.post("/exchange/order-precondition/add", data);
  }

  addOCOOrder(data) {
    return $marketAxios.post("/exchange/oco/add", data);
  }
}

export default new ExchangeService();
